<template>
  <div>
    <b-row>
      <div class="text-center">
        <h3 class="mt-4">{{ $t('pages.campaign.campaign_detail.title') }}</h3>
        <p class="text-muted font-size-14  mb-5">
          {{ $t('pages.campaign.campaign_detail.subtitle') }}
        </p>
      </div>

      <b-col sm="12">
        <div class="mb-3">
          <label>{{ $t('pages.campaign.campaign_detail.campaign_name') }}</label>
          <input
              v-model="campaignName"
              name="name"
              type="text"
              class="form-control"
              :placeholder="$t('pages.campaign.campaign_detail.campaign_name_placeholder')"
              :class="{'is-invalid': $v.campaignName.$error}"
          />
          <div
              v-if="!$v.campaignName.required"
              class="invalid-feedback"
          >
            {{ $t('pages.campaign.campaign_detail.validations.campaign_name_required') }}
          </div>
          <div
              v-if="!$v.campaignName.minLength"
              class="invalid-feedback"
          >
            {{
              $t('pages.campaign.campaign_detail.validations.campaign_name_min', {val: $v.campaignName.$params.minLength.min})
            }}
          </div>
          <div
              v-if="!$v.campaignName.maxLength"
              class="invalid-feedback"
          >
            {{
              $t('pages.campaign.campaign_detail.validations.campaign_name_max', {val: $v.campaignName.$params.maxLength.max})
            }}

          </div>
        </div>
      </b-col>

      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">
            {{ $t('pages.campaign.campaign_detail.campaign_status') }}
            <hint>{{ $t('pages.campaign.campaign_detail.infos.status_info') }}</hint>
          </label>
          <b-form-select
              class="form-select"
              :options="statusOptions"
              v-model="status"
              text-field="name"
              value-field="value">
          </b-form-select>
        </div>
      </b-col>

      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">
            {{ $t('pages.campaign.campaign_detail.template') }}
            <hint>{{ $t('pages.campaign.campaign_detail.infos.template_info') }}</hint>
          </label>
          <TemplateSelector :templates="templates"
                            @selectedTemplate="selectedTemplate = $event"
                            @remove="selectedTemplate = null"
                            :invalid="$v.selectedTemplate.$error"
                            />
          <div
              v-if="!$v.selectedTemplate.required && $v.selectedTemplate.$error"
              class="invalid-feedback d-grid"
          >
            {{ $t('pages.campaign.campaign_detail.validations.template_required') }}
          </div>
        </div>
      </b-col>

      <b-col sm="12">
        <div class="mb-3">
          <label>
            {{ $t('pages.campaign.campaign_detail.marketplace') }}
            <hint>{{ $t('pages.campaign.campaign_detail.infos.marketplace_info') }}</hint>
          </label>
          <market-place-component v-model="selectedMarketPlaces"/>
        </div>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import MarketPlaceComponent from "../../../../../components/widgets/MarketPlaceComponent";
import EmailService from "../../../../../Services/Api/EmailService";
import TemplateSelector from "../../../../../components/widgets/TemplateSelector";

export default {
  name: "CampaignDetail",
  components: {MarketPlaceComponent, TemplateSelector},
  data() {
    return {
      campaignName: '',
      selectedTemplate: null,
      selectedMarketPlaces: null,
      templates: null,
      status: true,
      submitted: false,
      statusOptions: [
        {
          name: this.$t('pages.campaign.campaign_detail.status_options.active'),
          value: true
        },
        {
          name: this.$t('pages.campaign.campaign_detail.status_options.disabled'),
          value: false
        }
      ],
    }
  },
  validations: {
    campaignName: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(100)
    },
    selectedTemplate: {
      required
    },
  },
  methods: {
    async getCampaignTemplates() {
      const {data: templates} = await EmailService.campaignTemplates({})
      this.templates = templates.data
    },
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      const data = {
        name: this.campaignName,
        selectedTemplate: this.selectedTemplate,
        selectedMarketplaces: this.selectedMarketPlaces,
        status: this.status
      }
      this.$emit('on-validate', data, isValid)
      return isValid
    }
  },
  created() {
    this.getCampaignTemplates()
  }
}
</script>

<style scoped>

</style>